'use client';

import '../styles/index.css';
import { useEffect } from 'react';
import { eventTrackingService } from '@/services/eventTrackingService';

export default function RootLayout({
  children
}: {
  children: React.ReactNode;
}) {
  useEffect(() => {
    // Initialize session tracking when app loads
    eventTrackingService.initializeSessionTracking();
  }, []);

  return (
    <html lang="nb" className="overflow-x-hidden">
      <body className="overflow-x-hidden">{children}

        <script type="module" async src="https://static.rocket.new/rocket-web.js?_cfg=https%3A%2F%2Fgullklarl6170back.builtwithrocket.new&_be=https%3A%2F%2Fappanalytics.rocket.new&_v=0.1.17" />
        <script type="module" defer src="https://static.rocket.new/rocket-shot.js?v=0.0.2" /></body>
    </html>
  );
}
